import React, { Component } from 'react'
import Button from "reactstrap/es/Button"
import BulkChangeStatusModal from './BulkChangeStatusModalV3'
import { getLocalData } from "../../../services/StorageServices";
import { parseJwt } from "../../../share/parseToken";

class BulkChangeStatus extends Component {
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        const { resetBulkAll, reloadItems, closeMenu } = this.props
        const { isOpen } = this.state

        this.setState({
            isOpen: !isOpen
        })

        if (isOpen) {
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    render() {
        const { isOpen } = this.state
        const { items = [], selectedItems = [] } = { ...this.props }
        const token = getLocalData('accessToken')
        const roles = token !== '' && parseJwt(token).roles ? parseJwt(token).roles : []
        const rolesArr = roles.map(role => {
            return role.name
        })
        const listItems = items.filter(item => selectedItems.includes(item._id))
        const listItemsDisable = listItems.filter(itemH => (['labelled', 'packaged', 'cancelled', 'cancel-ship'].includes(itemH.production_status)))
        const disabledBtn = listItemsDisable.length > 0

        return (
            <div>
                <Button color="link" onClick={this._handleToggleModal} className="mr-1" disabled={disabledBtn}>Change status</Button>
                {isOpen && (
                    <BulkChangeStatusModal
                        {...this.props}
                        isOpen={isOpen}
                        roles={rolesArr}
                        handleToggleModal={this._handleToggleModal}
                    />
                )}
            </div>
        );
    }

}

export default BulkChangeStatus